

@if (isLoading) {
  <div class="deals-page-centered" id="dealsPage">
    <img [src]="loadingLogo" *ngIf="loadingLogo" draggable="false" />
    <div>loading...</div>
  </div>
} @else if (!deal2) {
  <div class="deals-page-centered" id="dealsPage">
    @if (tenant?.Branding?.LogoImageUrl) {
      <img [src]="tenant.Branding.LogoImageUrl" draggable="false" />
    }
    <div>somethings gone wrong...</div>
  </div>
} @else {
  <div class="deals-page" id="dealsPage" [ngClass]="{'isModal': isModal }">
    <div class="deals-page-header">
      <h1>{{ deal2.name }}</h1>
  
      <mat-icon id="close-deal" (click)="cancelDeal()">highlight_off</mat-icon>
    </div> 
  
    <div class="deals-page-content">
      @if (!tenant.SuppressProductImages && deal2.imageBase) {
        <div class="product-image-wrapper" 
             role="button" 
             tabindex="0"
             (click)="openImageLightbox(deal2.imageBase)"
             (keydown.enter)="openImageLightbox(deal2.imageBase)"
             (keydown.space)="openImageLightbox(deal2.imageBase)">
          <img [src]="deal2.imageBase" 
               class="product-image" 
               [alt]="deal2.name"
               [draggable]="false"/>
          <div class="zoom-overlay">
            <mat-icon>zoom_in</mat-icon>
          </div>
        </div>
      }
  
      <h2 class="deals-page-content-displayed-info-price-amount">{{ deal2.price }}</h2>
      <p class="deals-page-content-displayed-info-description">{{ deal2.description }}</p>
  
      @if (!deal2.available) {
        <span class="deals-page-content-displayed-info-price-amount" style="color: red; font-size: 20px">
          Sorry - This deal is currently unavailable
        </span>
      }
  
      <ul class="deals-page-content-selections-list-wrapper">
        @for (line2 of deal2.lines; track line2) {
          <li class="deals-page-content-selections-list-item">
            <div class="deals-page-content-selections-list-item-header"
                 [ngClass]="{'deal-line-selected': line2.selectedItem }"
                 (click)="toggleLineItem(line2)">
              <div class="deals-page-content-selections-list-item-header-label">
                <span>{{ $index + 1 }}.</span>

                @if (line2.selectedItem) {
                  {{ line2.selectedItem.name }}
                } @else if (line2.webSections) {
                  Choose your {{ line2.webSections }}
                } @else {
                  Choose {{ $index + 1 }}
                }
              </div>
              <mat-icon>expand_more</mat-icon>
            </div>
    
            @if (line2.expanded) {
              <ul class="deal-line-container">
                @for (lineItem of line2.items; track lineItem) {
                  <li class="deal-line" [ngClass]="{'deal-item-unavailable': !lineItem.available}">
                    @if (!tenant.SuppressProductImages && lineItem.imageBase) {
                      <img [src]="lineItem.imageBase" draggable="false" [alt]="lineItem.product.Name" loading="lazy"/>
                    }
        
                    <div class="deal-line-details">
                      <h2>{{ lineItem.product.Name }}</h2>
                      <span>{{ lineItem.product.Description }}</span>

                      @if (lineItem.nutritionSummary) {
                        <span>{{ lineItem.nutritionSummary }}</span>
                      }
                    </div>
        
                    <button class="deal-line-button" 
                            [ngStyle]="{'background-color': line2.selectedItem?.productId === lineItem.product.Id ? '#D5E8D4' : '' }"
                            (click)="addProductToDeal(lineItem, line2)">
                      <mat-icon>{{ line2.selectedItem?.productId === lineItem.product.Id ? 'done' : 'add'}}</mat-icon>
                    </button>
                  </li>
                }
              </ul>
            }
          </li>
        }
      </ul>
    </div>
  
    <div class="deals-page-footer">
      <button class="deals-page-footer-button button-action-1"
              id="btnAddToCart"
              [ngClass]="{ 'button-action-disabled': !isDealComplete() }"
              [disabled]="!isDealComplete()"
              (click)="addDealToCart()">
        <div style="display: flex;">
          <div style="display: flex; align-items: center; flex: 1;">
            <mat-icon style="margin-right: 3px">add_circle</mat-icon>
            <span>Add to cart</span>
          </div>
        </div>
      </button>
    </div>
  </div>
}

<ng-template #CustomiseProductModal>
  <app-product [productView]="productView" [occasion]="occasion" (onClose)="closeProductModal()"></app-product>
</ng-template>
